export default function () {
  this.loadPayables();
}
